/* ==========================================================================
   Kaufwerk – Tabs
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- Tabs (ARIA) ---------- */
  class TabsComponent extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll(':scope > .tabs__list [role="tab"]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
      });
      document.addEventListener('shopify:block:select', (event) => {
        const tab = this.tabs.find((t) => t === event.target);
        if (tab) this.select(tab);
      });
    }

    onKeydown(event, tab) {
      const index = this.tabs.indexOf(tab);
      let next = null;
      if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
      if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
      if (event.key === 'Home') next = this.tabs[0];
      if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
      if (next) {
        event.preventDefault();
        this.select(next);
        next.focus();
      }
    }

    select(tab) {
      this.tabs.forEach((other) => {
        const selected = other === tab;
        other.setAttribute('aria-selected', String(selected));
        other.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(other.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      panel?.querySelectorAll('slider-component').forEach((slider) => slider.update && slider.update());
    }
  }
  if (!customElements.get('tabs-component')) customElements.define('tabs-component', TabsComponent);

})();
